import { useNavigate } from 'react-router-dom';
import { IconArrowLeft, IconBrain, IconInfo, IconCheck } from '../components/Icons.js';

// ---------------------------------------------------------------------------
// SettingsPage — info pipeline & konfigurasi aktif
//
// Backend menggunakan Cloudflare Workers AI untuk generasi prompt.
// ---------------------------------------------------------------------------

export function SettingsPage() {
  const navigate = useNavigate();

  return (
    <div>
      <button className="btn-ghost tap-target" style={{ marginBottom: 16 }} onClick={() => navigate('/')}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <IconArrowLeft size={16} /> Kembali
        </span>
      </button>

      <h1 style={{ fontSize: 20, marginBottom: 4 }}>Pengaturan</h1>
      <p className="text-muted" style={{ fontSize: 13, marginBottom: 20 }}>
        Konfigurasi teknis platform aivigen oleh MuidSoft.
      </p>

      {/* Provider aktif */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <IconBrain size={16} />
          <strong style={{ fontSize: 14 }}>LLM Provider Aktif</strong>
        </div>

        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '6px 12px', borderRadius: 20,
          background: 'rgba(50,180,100,0.10)',
          border: '1px solid rgba(50,180,100,0.30)',
          fontSize: 13, color: 'var(--status-success, #2ecc71)',
          marginBottom: 8,
        }}>
          <IconCheck size={13} /> Cloudflare Workers AI (Llama 3.3 70B)
        </div>

        <p className="text-muted" style={{ fontSize: 12, margin: 0 }}>
          Provider dikelola di infrastruktur Cloudflare — tidak perlu API key terpisah.
          Model: <code style={{ fontSize: 11 }}>@cf/meta/llama-3.3-70b-instruct-fp8-fast</code>
        </p>
      </div>

      {/* Pipeline info */}
      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 20, marginTop: 4 }}>
        <h2 style={{ fontSize: 16, marginBottom: 4 }}>Pipeline Aktif</h2>
        <p className="text-muted" style={{ fontSize: 13, marginBottom: 12 }}>
          Pipeline saat ini adalah <strong>Prompt Generator Only</strong> — tidak ada image/video/voice generation di dalam app.
          Output berupa prompts copy-pasteable untuk tool eksternal.
        </p>

        <div className="card" style={{ fontSize: 12 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {([
              ['PLANNING',          'Inisialisasi job & simpan konteks (aspect ratio, durasi)'],
              ['CONCEPT_GENERATION','LLM generate 1 konsep kreatif (title, hook, angle)'],
              ['[pause]',           'User review & pilih konsep — atau buat konsep baru'],
              ['STORYBOARD_DRAFT',  'LLM buat scene-by-scene storyboard lengkap'],
              ['[pause]',           'User review, edit scene jika perlu, lalu approve'],
              ['PROMPT_EXPORT',     'LLM format prompts: Midjourney, Sora, Kling, Runway, Generic'],
              ['COMPLETED',         'Prompts + social captions siap disalin'],
            ] as [string, string][]).map(([stage, desc]) => (
              <div key={stage} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <code style={{
                  fontSize: 11,
                  color: stage.startsWith('[') ? 'var(--text-muted)' : 'var(--gold-300)',
                  minWidth: 148,
                  flexShrink: 0,
                  marginTop: 1,
                }}>
                  {stage}
                </code>
                <span className="text-muted">{desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Info tools */}
      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 20, marginTop: 20 }}>
        <h2 style={{ fontSize: 16, marginBottom: 4 }}>Output Tools</h2>
        <p className="text-muted" style={{ fontSize: 13, marginBottom: 12 }}>
          Setiap scene menghasilkan prompt terformat untuk 5 tool:
        </p>
        <div className="card" style={{ fontSize: 12 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {([
              ['Midjourney', 'Prompt gambar statis dengan parameter --ar dan gaya visual'],
              ['Sora',       'Deskripsi video pendek dengan instruksi gerakan kamera'],
              ['Kling',      'Prompt video motion dengan durasi dan style'],
              ['Runway',     'Gen-3 Alpha prompt dengan kamera dan mood'],
              ['Generic',    'Prompt universal untuk tool AI video lainnya'],
            ] as [string, string][]).map(([tool, desc]) => (
              <div key={tool} style={{ display: 'flex', gap: 10 }}>
                <span style={{ fontWeight: 600, minWidth: 90, color: 'var(--gold-300)', fontSize: 11 }}>{tool}</span>
                <span className="text-muted">{desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="text-muted" style={{ fontSize: 11, marginTop: 20, display: 'flex', alignItems: 'flex-start', gap: 5 }}>
        <IconInfo size={13} style={{ flexShrink: 0, marginTop: 1 }} />
        Konfigurasi server (secrets, model, binding Cloudflare) dikelola via Wrangler —
        tidak bisa diubah dari UI ini.
      </p>
    </div>
  );
}
